import React from 'react';
import { MapPin, Calendar } from 'lucide-react';
import { usePortfolio } from '../context/PortfolioContext';

const ExperienceSection = () => {
  const { experience, loading } = usePortfolio();
  return (
    <section id="experience" className="bg-white py-24 md:py-32 relative">
      {/* Section Divider */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#e2e8f0] to-transparent" />

      <div className="max-w-[87.5rem] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="mb-16">
          <span className="text-[#2563eb] text-sm uppercase tracking-widest font-semibold">My Journey</span>
          <h2 className="text-4xl md:text-6xl font-black text-[#1e3a5f] mt-2">
            Work <span className="text-[#2563eb]">Experience</span>
          </h2>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-px bg-[#e2e8f0] transform md:-translate-x-1/2" />

          <div className="space-y-12">
            {experience.map((exp, index) => (
              <div
                key={exp.id}
                className={`relative flex flex-col md:flex-row gap-8 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Timeline Dot */}
                <div className="absolute left-0 md:left-1/2 w-4 h-4 bg-[#2563eb] rounded-full transform -translate-x-1/2 border-4 border-white z-10 shadow-lg" />

                {/* Content Card */}
                <div
                  className={`ml-8 md:ml-0 md:w-1/2 ${
                    index % 2 === 0 ? 'md:pr-16' : 'md:pl-16'
                  }`}
                >
                  <div className="bg-[#f8fafc] border border-[#e2e8f0] rounded-2xl p-8 hover:border-[#2563eb]/30 hover:shadow-lg transition-all duration-300 group">
                    {/* Header */}
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <h3 className="text-[#1e3a5f] font-bold text-xl group-hover:text-[#2563eb] transition-colors">
                          {exp.role}
                        </h3>
                        <p className="text-[#2563eb] font-semibold mt-1">{exp.company}</p>
                      </div>
                      <span className="text-xs uppercase bg-[#2563eb]/10 text-[#2563eb] px-3 py-1 rounded-full font-semibold">
                        {exp.type}
                      </span>
                    </div>

                    {/* Meta Info */}
                    <div className="flex flex-wrap gap-4 text-[#64748b] text-sm mb-6">
                      <div className="flex items-center gap-2">
                        <Calendar size={14} />
                        <span>{exp.period}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <MapPin size={14} />
                        <span>{exp.location}</span>
                      </div>
                    </div>

                    {/* Responsibilities */}
                    <ul className="space-y-3">
                      {exp.responsibilities.map((resp, idx) => (
                        <li key={idx} className="flex items-start gap-3 text-[#64748b]">
                          <span className="w-1.5 h-1.5 bg-[#2563eb] rounded-full mt-2 flex-shrink-0" />
                          <span className="text-sm leading-relaxed">{resp}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Empty Space for alternating layout */}
                <div className="hidden md:block md:w-1/2" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
